import { RequestFormSettings } from "../Schemas/RequestFormState";
import { Request } from "./mappers";

/**
 * Whether the attachment upload UI (drop zones / `<Attachments />` body) may show at all.
 * Per-taxonomy zones still require preview and file-limit checks.
 */
export function areAttachmentUploadDropzonesGloballyVisible(
    request: Request,
    settings: RequestFormSettings,
): boolean {
    const files = request.files || [];
    const enabledOrRequiredOrHasFiles =
        settings.attachmentsEnabled || settings.attachmentsRequired || files.length > 0;

    const visible =
        (request.isSubmitted && request.hasGeneratedDocument) ||
        (((!settings.disableImmediateFileUpload && request.canUploadFiles) ||
            (settings.manualSignRequired === true &&
                (request.ismanuallySigned === false || request.ismanuallySigned === true) &&
                !request.isSubmitted)) &&
            settings.requestHasTaxonomies) ||
        (settings.disableImmediateFileUpload &&
            request.canUploadFiles &&
            request.requestId &&
            enabledOrRequiredOrHasFiles);

    return Boolean(visible);
}
